// extracted by css-extract-rspack-plugin
export default {"cls1":"ReferenceReportPage-cls1_j1E","cls2":"ReferenceReportPage-cls2_fak ReferenceReportPage-cls1_j1E"};